<template>
    <div class="Footer">
        <div class="footerUpperHalf">
            <div class="upperLeft upperItemBox">
                <div class="upperItemTitle">
                    <span class="phoneNum">400-0827-880</span>
                </div>
                <div class="upperItemContent">
                    <div class="addressList">
                        <div class="address">总部：中国·杭州西湖区古墩路天亿大厦16楼</div>
                        <div class="address">广州分公司：广州市荔湾区芳村大道东200号1850创意园50-1栋二楼</div>
                        <div class="address">常州分公司：江苏省常州市新北区河海商务大厦7楼</div>
                    </div>
                </div>
            </div>
            <div class="halvingLine"></div>
            <div class="upperLeft upperItemBox">
                <div class="upperItemTitle">
                    <span class="blueUndertext">帮助中心</span>
                </div>
                <div class="upperItemContent">
                    <div class="helpBox">
                        <div class="helpItem">渠道合作</div>
                        <div class="helpItem">服务咨询</div>
                        <a class="helpItem" href="http://wpa.qq.com/msgrd?v=3&uin=2697876348&site=qq&menu=yes" target="_blank">联系客服</a>
                        <a class="helpItem" href="http://help.020leader.com" target="_blank">支付宝企业帮助中心</a>
                    </div>
                </div>
            </div>
            <div class="halvingLine"></div>
            <div class="upperContent upperItemBox">
                <div class="upperItemTitle">
                    <span class="blueUndertext">关注我们</span>
                </div>
                <div class="upperItemContent">
                    <a class="helpItem" href="http://weibo.com/020ylkj" target="_blank">官方微博</a>
                    <div class="helpItem">官方微信</div>
                    <div class="phoneCenter">
                        <img class="weixinQRCode" src="@/assets/images/layout/qrcode.jpg" alt="">
                    </div>
                </div>
            </div>
            <div class="halvingLine"></div>
            <div class="upperRight upperItemBox">
                <div class="upperItemTitle">
                    <span class="blueUndertext">合作伙伴</span>
                </div>
                <div class="upperItemContent">
                    <div class="cooperationBox">
                        <img class="cooperationImg" src="@/assets/images/layout/hz1.png" alt=""/>
                        <img class="cooperationImg" src="@/assets/images/layout/hz4.png" alt=""/>
                        <img class="cooperationImg" src="@/assets/images/layout/hz6.png" alt=""/>
                        <img class="cooperationImg" src="@/assets/images/layout/hz2.png" alt=""/>
                        <img class="cooperationImg" src="@/assets/images/layout/hz5.png" alt=""/>
                        <img class="cooperationImg" src="@/assets/images/layout/hz3.png" alt=""/>
                    </div>
                </div>
            </div>
        </div>
        <div class="blogrollBox">
            <span class="friendText">友情链接:</span>
            <a class="blogrollItem" href="">武汉网站建投</a>
            <a class="blogrollItem" href="">东莞网站制作</a>
            <a class="blogrollItem" href="">海蚂蚁全球购</a>
            <a class="blogrollItem" href="">杭州注册公司</a>
            <a class="blogrollItem" href="">青岛网站建设</a>
            <a class="blogrollItem" href="">自动售货机</a>
            <a class="blogrollItem" href="">昆山赛格电子市场</a>
            <a class="blogrollItem" href="">进口电器</a>
        </div>
        <div class="footerLowerHalf">
            <div>
                <span>Copyright©2014-2019 杭州移领网络科技有限公司 版权所有</span>
            </div>
            <div class="beian">
                <div class="beianBox">
                    <img src="@/assets/images/icon/beian.png" alt="" class="beianImg">
                    <a href="https://beian.miit.gov.cn" target="_blank">浙公网安备&nbsp;33010602004156号</a>
                </div>
                <div class="beianBox">
                    <img src="@/assets/images/icon/beian.png" alt="" class="beianImg">
                    <a href="https://beian.miit.gov.cn" target="_blank">浙公网安备&nbsp;33010602004162号</a>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>

export default {
    name:'Footer',
    components: {},
    props:{},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {},
}
</script>
<style scoped>
a{
    text-decoration: none;
    color: #ccc;
}
.blueUndertext{
    padding-bottom: 5px;
    /* border-bottom: 1px solid #01c2e1; */
}
.Footer{
    width: 100%;
    height: 320px;
    color: #fff;
}
.footerUpperHalf{
    height: 190px;
    font-size: 14px;
    color: #aaaaaa;
    background: #333333;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 80px;
}
.footerLowerHalf{
    font-size: 12px;
    color: #ccc;
    height: 60px;
    background: #333333;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.beianBox{
    margin-top: 5px;
    display: flex;
    align-items: center;
    float: left;
    margin-right: 40px;
}
.beianImg{
    width: 18px;
    height: 18px;
    margin-right: 3px;
}

.upperItemBox{
    height: 100%;
    padding: 20px 0;
    box-sizing: border-box;
}
.upperItemTitle{
    font-size: 16px;
    color: #fff;
    text-align: left;
    margin-bottom: 20px;
}
.halvingLine{
    width: 1px;
    height: 160px;
    background-color: #5b5b5b;
}
.phoneCenter{
    margin: 10px 0;
    display: flex;
    align-items: center;
}
.phoneIcon{
    width: 38px;
    height: 38px;
    margin-right: 10px;
}
.phoneNum{
    font-size: 22px;
}
.weixinQRCode{
    width: 80px;
}
.cooperationBox{
    max-width: 180px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.cooperationImg{
    width: 80px;
    margin-bottom: 10px;
}

.addressList{
    max-width: 320px;
}
.address,.helpItem{
    color: #aaaaaa;
    display: block;
    text-align: left;
    margin-bottom: 5px
}
.blogrollBox{
    width: 100%;
    height: 70px;
    background-color: #333333;
    color: #aaaaaa;
    font-size: 12px;
    padding: 40px 0 20px 0;
    border-bottom: 1px solid #5b5b5b;
    box-sizing: border-box;
}
.blogrollItem{
    color: #aaaaaa;
    padding: 0 20px;
    border-right: 1px solid #5b5b5b;
}
.blogrollBox a:last-child{
    border-right:none
}
</style>